<div class="statement-generator-container">
  <div class="card">
    <div class="card-header">
      <h4>
        <mat-icon class="mr-2">auto_awesome</mat-icon>
        {{ 'statement-generator.title' | translate }}
      </h4>
    </div>

    <div class="card-body p-0">
      <!-- Tab Navigation -->
      <mat-tab-group [(selectedIndex)]="selectedTabIndex" class="statement-tabs" animationDuration="300ms">

        <!-- Tab 0: PICO -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon class="mr-2">psychology</mat-icon>
            P.I.C.O.S.T.
          </ng-template>
          <div class="tab-content p-4">
            @if (projectData && userService.currentOrganizationHasFeature('pico')) {
              <mat-card class="login-card">
                <mat-card-content>
                  <form>
                    <mat-form-field class="full-width" subscriptSizing="dynamic">
                      <mat-label>{{ 'components.decision-table.pico.patients' | translate }}</mat-label>
                      <input matInput [(ngModel)]="patients" name="patients" required />
                    </mat-form-field>
                    <mat-form-field class="full-width" subscriptSizing="dynamic">
                      <mat-label>Intervention</mat-label>
                      <input matInput [(ngModel)]="intervention" name="intervention" required>
                    </mat-form-field>
                    <mat-form-field class="full-width" subscriptSizing="dynamic">
                      <mat-label>{{ 'components.decision-table.pico.comparison' | translate }}</mat-label>
                      <input matInput [(ngModel)]="comparison" name="comparison" required>
                    </mat-form-field>
                    <mat-form-field class="full-width" subscriptSizing="dynamic">
                      <mat-label>{{ 'components.decision-table.pico.outcome' | translate }}</mat-label>
                      <input matInput [(ngModel)]="outcomes" name="outcomes" required>
                    </mat-form-field>
                    <mat-form-field class="full-width" subscriptSizing="dynamic">
                      <mat-label>S – Studies</mat-label>
                      <input matInput [(ngModel)]="studies" name="studies">
                    </mat-form-field>
                    <mat-form-field class="full-width" subscriptSizing="dynamic">
                      <mat-label>T – Timeframe</mat-label>
                      <input matInput [(ngModel)]="timeframe" name="timeframe">
                    </mat-form-field>
                    <div class="{{ picoQuestionStatus !== 'ready' ? 'row justify-content-center my-3' : '' }}">
                      @if (!picoQuestionStatus) {
                        <button mat-raised-button color="primary" (click)="generatePICOQuestion()">{{ 'components.decision-table.pico.generate-pico-question' | translate }}</button>
                      }
                      @if (picoQuestionStatus === 'pending') {
                        <mat-spinner diameter="40"></mat-spinner>
                      }
                    </div>
                    @if (picoQuestionStatus === 'ready' || !picoQuestionStatus) {
                      <span class="text-muted">{{ 'components.decision-table.pico.generated-pico-search-question' | translate }}</span>
                      <div class="box flex-column my-0 pb-0 pt-5 px-3 bordered">
                        <mat-form-field class="full-width">
                          <textarea disabled class="description" matInput rows="2" name="pico_response" [(ngModel)]="question" readonly></textarea>
                        </mat-form-field>
                      </div>
                    }
                    @if (picoQuestionStatus === 'ready' && keywordsForChipList.length > 0) {
                      <div class="container my-4">
                        <mat-card class="login-card">
                          <mat-card-content>
                            <h4 class="mb-3">Keywords</h4>
                            <mat-form-field class="full-width" subscriptSizing="dynamic">
                              <mat-chip-grid #chipList aria-label="Keyword List">
                                @for (keyword of keywordsForChipList; track keyword) {
                                  <mat-chip-row color="accent" selected highlighted
                                    (removed)="removeKeyword(keyword)" [removable]="true">
                                    {{keyword}}
                                    <button matChipRemove [attr.aria-label]="'cancel'">
                                      <mat-icon>cancel</mat-icon>
                                    </button>
                                  </mat-chip-row>
                                }
                                <input
                                  placeholder="Add new keyword..."
                                  [matChipInputFor]="chipList"
                                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                  (matChipInputTokenEnd)="addKeyword($event)"
                                />
                              </mat-chip-grid>
                            </mat-form-field>
                          </mat-card-content>
                        </mat-card>
                      </div>
                      <div class="d-flex flex-column align-items-center gap-2 mb-3">
                        @if (biblioSearchStatus === 'pending') {
                          <mat-spinner diameter="40"></mat-spinner>
                        } @else {
                          <div class="d-flex flex-column align-items-center gap-1">
                            <span class="text-muted small">#Papers</span>
                            <mat-button-toggle-group [(value)]="pubmedSearchLimit" aria-label="Number of results">
                              @for (n of [10,20,30,40,50,60,70,80,90,100]; track n) {
                                <mat-button-toggle [value]="n">
                                  {{ n }}<ng-container *ngIf="n === 10"><sup style="font-size:8px;margin-left:1px"></sup></ng-container>
                                </mat-button-toggle>
                              }
                            </mat-button-toggle-group>
                          </div>
                          <hr class="w-100 my-1">
                          <button mat-raised-button color="primary" (click)="searchTermInPublmedEnhanced(true)">
                            {{ 'modals.select-inputs.search-pubmed' | translate }}
                          </button>
                        }
                      </div>
                    }
                  </form>
                </mat-card-content>
              </mat-card>
            } @else {
              <div class="alert alert-info m-4">
                <mat-icon class="mr-2">info</mat-icon>
                Funzionalità PICO non disponibile per questa organizzazione.
              </div>
            }
          </div>
        </mat-tab>

        <!-- Tab 1: Letteratura scientifica (Upload Papers) -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon class="mr-2">upload_file</mat-icon>
            <!-- Letteratura scientifica -->
            {{ 'components.statement-generator.tabs.literature' | translate }}
          </ng-template>

          <div class="tab-content p-4">
            <div class="section">
              <h5 class="section-title mb-4">
                <mat-icon class="mr-2">article</mat-icon>
                <!-- Carica articoli scientifici per l'elaborazione -->
                 {{'components.statement-generator.literature.section-title' | translate}}
              </h5>

              <!-- <div class="alert alert-info mb-4">
                <mat-icon class="mr-2">info</mat-icon>
                <div>
                  Carica uno o più articoli scientifici in formato PDF. I documenti verranno elaborati per estrarre informazioni rilevanti per la generazione di statement.
                </div>
              </div> -->

              <div class="text-center mb-4">
                <button
                  mat-button
                  type="button"
                  class="allega-evidenze-btn"
                  [matMenuTriggerFor]="menuAttachment">
                  <i class="icon-upload mr-2"></i>
                  <!-- Carica articoli scientifici -->
                   {{ 'components.statement-generator.literature.upload-button' | translate }}
                </button>
                <mat-menu #menuAttachment="matMenu">
                  <button mat-menu-item (click)="openUploadPapersModal('FILE')">
                    <mat-icon aria-hidden="false" class="attachment-evidence-icon">file_upload</mat-icon>
                    File
                  </button>
                  <button mat-menu-item (click)="openUploadPapersModal('PUBMED')">
                    <mat-icon aria-hidden="false" class="attachment-evidence-icon">science</mat-icon>
                    PubMed
                  </button>
                </mat-menu>
              </div>

              @if (uploadedPapers.length > 0) {
                <div class="uploaded-files-section">
                  <div class="d-flex align-items-center justify-content-between mb-3">
                    <h6 class="subsection-title mb-0">
                      <mat-icon class="mr-2">description</mat-icon>
                      {{ 'components.statement-generator.literature.uploaded-docs' | translate }} ({{ uploadedPapers.length }})
                    </h6>
                    @if (uploadedPapers.length > 0) {
                      <button mat-stroked-button color="primary" (click)="exportLiteratureToExcel()" class="export-btn">
                        <mat-icon>download</mat-icon>
                        Export Excel
                      </button>
                    }
                  </div>

                  <div class="table-responsive">
                    <table class="table table-hover attachments-table">
                      <thead>
                        <tr>
                          <th>Type</th>
                          <th>Authors</th>
                          <th>Title</th>
                          <th>Year</th>
                          <th>Study Type</th>
                          <th>Main Outcome</th>
                          <th>Extracted</th>
                          <th>Status</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (paper of uploadedPapers; track $index; let i = $index) {
                          <tr>
                            <td>
                              <span class="type-badge" [ngClass]="paper.type === 'PUBMED' ? 'type-pubmed' : 'type-file'">
                                {{ paper.type === 'PUBMED' ? 'PubMed' : 'File' }}
                              </span>
                            </td>
                            <td class="authors-cell">
                              <span [title]="paper.authors">
                                {{ paper.authors ? ((paper.authors | slice:0:40) + (paper.authors.length > 40 ? '...' : '')) : '-' }}
                              </span>
                            </td>
                            <td class="file-cell">
                              @if (paper.type === 'PUBMED' && paper.link) {
                                <a [href]="paper.link" target="_blank" class="file-title pubmed-link" [title]="paper.title" rel="noopener noreferrer">
                                  {{ paper.title ? ((paper.title | slice:0:60) + (paper.title.length > 60 ? '...' : '')) : '-' }}
                                  <mat-icon class="external-link-icon">open_in_new</mat-icon>
                                </a>
                              } @else {
                                <span [title]="paper.title">
                                  {{ paper.title ? ((paper.title | slice:0:60) + (paper.title.length > 60 ? '...' : '')) : '-' }}
                                </span>
                              }
                              @if (paper.type === 'PUBMED' && paper.PMID) {
                                <div class="pubmed-id-text">PMID: {{ paper.PMID }}</div>
                              }
                            </td>
                            <td>{{ paper.year || paper.pubyear || '-' }}</td>
                            <td>{{ paper.study_type || '-' }}</td>
                            <td class="reason-cell">{{ paper.main_outcome || '-' }}</td>
                            <td class="reason-cell">
                              @if (paper.llm_analysis) {
                                <button type="button" class="btn-view-analysis" (click)="openAnalysisDialog(paper.title, paper.llm_analysis)" title="View AI Analysis">
                                  <mat-icon class="analysis-icon">psychology</mat-icon>
                                  <span>View</span>
                                </button>
                              } @else if (paper.reason) {
                                <button type="button" class="btn-view-error" (click)="openAnalysisDialog(paper.title, paper.reason, true)" title="View Error">
                                  <mat-icon class="error-icon">error_outline</mat-icon>
                                  <span>Error</span>
                                </button>
                              } @else {
                                <span class="text-muted">-</span>
                              }
                            </td>
                            <td>
                              <span class="status-badge-table"
                                    [ngClass]="{
                                      'status-waiting': paper.status === 'waiting',
                                      'status-processing': paper.status === 'processing',
                                      'status-processed': paper.status === 'processed' || paper.status === 'completed',
                                      'status-failed': paper.status === 'failed'
                                    }">
                                <mat-icon class="status-icon-small">
                                  @if (paper.status === 'waiting') { schedule }
                                  @if (paper.status === 'processing') { sync }
                                  @if (paper.status === 'processed' || paper.status === 'completed') { check_circle }
                                  @if (paper.status === 'failed') { error }
                                </mat-icon>
                                {{ paper.status || 'waiting' }}
                              </span>
                            </td>
                            <td class="actions-cell">
                              <button type="button" class="btn-action btn-delete" [disabled]="isProcessingPapers" (click)="removePaper(i)" title="Remove">
                                <mat-icon>delete</mat-icon>
                              </button>
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>

                  <div class="mt-4 text-center">
                    <button
                      type="button"
                      class="btn btn-lg btn-ai-analysis"
                      [disabled]="uploadedPapers.length === 0 || isProcessingPapers || allDocumentsCompleted"
                      [matTooltip]="allDocumentsCompleted ? 'All documents are already analyzed' : ''"
                      (click)="processLiteratureReview()">
                      @if (!isProcessingPapers) {
                        <mat-icon class="mr-2">psychology</mat-icon>
                      }
                      @if (isProcessingPapers) {
                        <mat-spinner diameter="20" class="mr-2" [style.display]="'inline-block'"></mat-spinner>
                      }
                      {{ isProcessingPapers ? 'AI Analysis progress...' : (allDocumentsCompleted ? 'AI Analysis completed' : 'AI Analysis') }}
                    </button>
                  </div>
                </div>
              }
            </div>
          </div>
        </mat-tab>

        <!-- Tab 2: Compilazione Guidata -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon class="mr-2">description</mat-icon>
            <!-- Compilazione Guidata -->
            {{ 'components.statement-generator.tabs.guided-compilation' | translate }}
          </ng-template>

          <div class="tab-content p-4">
            <!-- Inline generation progress (shown while generation is running or failed) -->
            @if (showProgressMonitor && newGenerationState.processId) {
              <div class="inline-progress-section mb-4">
                <app-statement-progress-monitor
                  [status]="newGenerationState"
                  (onClose)="handleCloseProgressMonitor()"
                  (onViewStatements)="handleViewStatementsFromMonitor()"
                  (onRetry)="handleRetryGeneration()">
                </app-statement-progress-monitor>
              </div>
            }

            <!-- Form stays mounted (hidden via [hidden]) so user data is preserved
                 across success/failure of the generation cycle. Using @if would
                 destroy the component and lose all form state. -->
            <div [hidden]="showProgressMonitor && newGenerationState.status !== 'failed'">
              <app-statement-generator-form
                #formRef
                [projectId]="projectId"
                [projectData]="projectData"
                [picoData]="picoData"
                [currentPicoTabData]="{population: patients, intervention: intervention, comparison: comparison, outcomes: outcomes}"
                [previousSurveysAvailable]="previousSurveysAvailable"
                [existingLiterature]="availableLiterature"
                (formSubmitted)="onFormSubmitted($event)"
                (formCanceled)="onFormCanceled()"
                (draftSaved)="onDraftSaved($event)"
                (picoImported)="onPicoImported($event)">
              </app-statement-generator-form>
            </div>
          </div>
        </mat-tab>

        <!-- Tab 2: Selezione Rapida -->
        <!-- <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon class="mr-2">flash_on</mat-icon>
            Selezione Rapida
          </ng-template>

          <div class="tab-content p-4">
            <div class="section mb-4">
              <h5 class="section-title">
                <mat-icon class="mr-2">input</mat-icon>
                {{ 'statement-generator.select-inputs' | translate }}
              </h5>

              <div class="d-flex justify-content-between align-items-center mb-3">
                <button
                  type="button"
                  class="btn btn-outline-primary"
                  style="border-color: #6c5ce7; color: #6c5ce7;"
                  (click)="openInputSelector()">
                  <mat-icon class="mr-1">add</mat-icon>
                  {{ 'statement-generator.add-inputs-button' | translate }}
                </button>

                @if (hasUserInputs) {
                  <button
                    type="button"
                    class="btn btn-outline-secondary btn-sm"
                    (click)="clearAllInputs()">
                    <mat-icon class="mr-1">clear_all</mat-icon>
                    {{ 'generic.clear-all' | translate }}
                  </button>
                }
              </div>

              @if (selectedInputs.length > 0) {
                <div class="selected-inputs-container">
                  <div class="alert alert-info mb-3 d-flex align-items-start">
                    <mat-icon class="alert-info-icon flex-shrink-0 mr-2">info</mat-icon>
                    <strong>{{ selectedInputs.length }}</strong>
                    {{ selectedInputs.length === 1 ? ('statement-generator.input-selected' | translate) : ('statement-generator.inputs-selected' | translate) }}
                  </div>
                  <div class="inputs-list">
                    @for (input of selectedInputs; track input; let i = $index) {
                      <div
                        class="input-item-card"
                        [class.context-input]="input.type === 'project_details' || input.type === 'pico'">
                        <div class="input-icon">
                          <mat-icon [class]="'type-' + input.type">{{ getInputIcon(input.type) }}</mat-icon>
                        </div>
                        <div class="input-details">
                          <div class="input-name">{{ input.name }}</div>
                          <div class="input-meta">
                            <span class="badge badge-secondary">{{ getInputTypeLabel(input.type) }}</span>
                            @if (input.metadata?.participants) {
                              <span class="ml-2 text-muted">
                                {{ input.metadata.participants }} {{ 'statement-generator.participants' | translate }}
                              </span>
                            }
                            @if (input.metadata?.uploadDate) {
                              <span class="ml-2 text-muted">
                                {{ input.metadata.uploadDate | date:'dd/MM/yyyy' }}
                              </span>
                            }
                          </div>
                        </div>
                        @if (input.type !== 'project_details' && input.type !== 'pico') {
                          <button
                            type="button"
                            class="btn btn-sm btn-outline-danger"
                            (click)="removeInput(i)">
                            <mat-icon>close</mat-icon>
                          </button>
                        }
                        @if (input.type === 'project_details' || input.type === 'pico') {
                          <span class="badge badge-info">
                            {{ 'statement-generator.auto-included' | translate }}
                          </span>
                        }
                      </div>
                    }
                  </div>
                </div>
              }

              @if (selectedInputs.length === 0) {
                <div class="alert alert-warning">
                  <mat-icon class="mr-2">info</mat-icon>
                  {{ 'statement-generator.no-inputs-selected-message' | translate }}
                </div>
              }
            </div>

            <div class="section mb-4 text-center">
              <button
                type="button"
                class="btn btn-lg btn-generate"
                [disabled]="selectedInputs.length === 0 || isGenerating"
                (click)="generateStatements()">
                @if (!isGenerating) {
                  <mat-icon class="mr-2">auto_awesome</mat-icon>
                }
                @if (isGenerating) {
                  <mat-spinner diameter="20" class="mr-2" [style.display]="'inline-block'"></mat-spinner>
                }
                {{ isGenerating ? ('statement-generator.generating' | translate) : ('statement-generator.generate-button' | translate) }}
              </button>

              @if (isGenerating) {
                <div class="generation-progress mt-3">
                  <mat-progress-bar mode="determinate" [value]="generationProgress" color="primary"></mat-progress-bar>
                  <p class="text-muted mt-2">{{ generationMessage }}</p>
                </div>
              }
            </div>

            @if (needsInput) {
              <div class="section mb-4">
                <div class="alert alert-warning needs-input-alert">
                  <div class="alert-header">
                    <mat-icon class="mr-2" style="vertical-align: middle;">info</mat-icon>
                    <strong>{{ 'statement-generator.needs-more-data-title' | translate }}</strong>
                  </div>
                  <p class="mt-2 mb-3">{{ needsInputMessage }}</p>
                  @if (needsInputSuggestions.length > 0) {
                    <div class="suggestions-container">
                      <p class="mb-2"><strong>{{ 'statement-generator.suggestions' | translate }}:</strong></p>
                      <ul class="suggestions-list">
                        @for (suggestion of needsInputSuggestions; track suggestion) {
                          <li class="suggestion-item">
                            <mat-icon class="suggestion-icon">lightbulb</mat-icon>
                            {{ suggestion }}
                          </li>
                        }
                      </ul>
                    </div>
                  }
                  <div class="mt-3 d-flex gap-2">
                    <button type="button" class="btn btn-primary" (click)="openInputSelector()">
                      <mat-icon class="mr-1">add</mat-icon>
                      {{ 'statement-generator.add-more-sources' | translate }}
                    </button>
                    <button type="button" class="btn btn-outline-secondary" (click)="retryGeneration()">
                      <mat-icon class="mr-1">close</mat-icon>
                      {{ 'generic.buttons.dismiss' | translate }}
                    </button>
                  </div>
                </div>
              </div>
            }
          </div>
        </mat-tab> -->

        <!-- Tab 3: Generated Statements -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon class="mr-2">fact_check</mat-icon>
            Statement Generati
            @if (newGenerationState.statements.length > 0) {
              <span class="tab-badge ml-2">{{ newGenerationState.statements.length }}</span>
            }
          </ng-template>

          <div class="tab-content p-0">
            @if (lastCreatedSurveyId) {
              <div class="survey-created-banner">
                <mat-icon>check_circle</mat-icon>
                <span>{{ 'components.statement-generator.generated.survey-created' | translate }}</span>
                <!-- <span>Survey creata con successo.</span> -->
                <a [href]="'/#/surveys/' + lastCreatedSurveyId" target="_blank" class="survey-link">
                  {{ 'components.statement-generator.generated.open-survey' | translate }}
                  <mat-icon style="font-size:14px;height:14px;width:14px;vertical-align:middle;">open_in_new</mat-icon>
                  <!-- Apri Survey <mat-icon style="font-size:14px;height:14px;width:14px;vertical-align:middle;">open_in_new</mat-icon> -->
                </a>
              </div>
            }
            @if (newGenerationState.statements.length > 0) {
              <app-statement-review
                [statements]="newGenerationState.statements"
                [sections]="newGenerationState.sections"
                [surveyMetadata]="newGenerationState.surveyMetadata"
                [projectTitle]="newGenerationState.processName || ''"
                [selectedStatementIds]="newGenerationState.selectedStatementIds"
                (selectionChange)="handleSelectionChange($event)"
                (addToSurvey)="handleAddToSurvey($event)"
                (exportStatements)="handleExport($event)">
              </app-statement-review>
            }
            @if (newGenerationState.statements.length === 0) {
              <div class="empty-statements p-5 text-center">
                <mat-icon style="font-size: 48px; color: #ccc; width: 48px; height: 48px;">fact_check</mat-icon>
                <h5 class="mt-3 text-muted">{{ 'components.statement-generator.generated.empty-title' | translate }}</h5>
                <!-- <h5 class="mt-3 text-muted">Nessun statement generato</h5> -->
                <p class="text-muted">{{ 'components.statement-generator.generated.empty-description' | translate }}</p>
                <!-- <p class="text-muted">Usa la tab "Compilazione Guidata" o "Selezione Rapida" per generare statement.</p> -->
              </div>
            }
          </div>
        </mat-tab>

      </mat-tab-group>
    </div>
  </div>
</div>
